import { Component, OnInit, inject } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'

import { Enums, Profile } from '@cyborg-monorepo/hunter/common'
import { DialogRef } from '@hyperkit'

import { UserService } from '../../../../shared/services/user.service'

@Component({
  standalone: false,
  selector: 'new-user-dialog',
  templateUrl: './new-user-dialog.component.html',
  styleUrls: ['./new-user-dialog.component.scss'],
})
export class NewUserDialogComponent implements OnInit {
  dialogRef = inject(DialogRef)
  private userService = inject(UserService)

  public formGroup: FormGroup
  public roles: Array<string> = []
  public error: string

  public ngOnInit(): void {
    this.formGroup = new FormGroup({
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required, Validators.email]),
      role: new FormControl(Enums.UserRoleEnum.ADMINISTRATOR, [
        Validators.required,
      ]),
    })

    this.roles = Object.values(Enums.UserRoleEnum)
  }

  public onSubmit(): void {
    this.userService.createUser(this.formGroup.value).subscribe(
      (user: Profile) => {
        this.dialogRef.close(user)
      },
      (error) => {
        this.error = error.message
      },
    )
  }

  public onClose(): void {
    this.dialogRef.close()
  }
}
